import { Session } from "../models/sessions.model";

export function getSessionAndOneLevelChildren(sessions: Session[], sessionId: string): Session[] {
  return sessions.filter((s) => s.id === sessionId || s.parentId === sessionId);
}
